import React from 'react';
import { Container } from '@mui/material';
import { PayRiseForm } from '../features/pay-rise-simulator';
import { makeMeta, makeWebsiteJsonLd } from '../utils/seo';

const PayRiseSimulatorPage = () => {
  // Default to 50k - in future could get from URL params or local storage
  const currentSalary = 50000;

  const websiteData = makeWebsiteJsonLd({
    siteName: 'SalaryTools',
    url: 'https://salarytools.co.uk/pay-rise-simulator'
  });

  return (
    <>
      {makeMeta({
        title: 'Pay Rise Simulator - Calculate Real After-Tax Impact',
        description: 'Understand the real impact of salary increases after tax, National Insurance, and deductions. See how much of your raise you actually keep and get negotiation guidance.',
        canonical: 'https://salarytools.co.uk/pay-rise-simulator',
        jsonLd: [websiteData]
      })}
      
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <PayRiseForm currentSalary={currentSalary} />
      </Container>
    </>
  );
};

export default PayRiseSimulatorPage;